import { ANY_OBJECT } from '@app/interfaces/interfaces';

export const roleColumns: Array<ANY_OBJECT> = [
  {
    title: 'roles.table.key',
    dataIndex: 'id',
    width: 'auto',
    editable: false,
    align: 'center' as const,
    render: (text: string, record: ANY_OBJECT, index: number) => index + 1,
    sorter: (a: ANY_OBJECT, b: ANY_OBJECT) => a.id - b.id,
  },
  {
    title: 'roles.table.role',
    dataIndex: 'role',
    width: 'auto',
    editable: false,
    inputType: 'roleSelect',
    align: 'center' as const,
    render: (text: string, record: ANY_OBJECT) => record?.role || '',
  },
];
